var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "#012169"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 24,18 M24,0 0,18",
    stroke: "#fff",
    strokeWidth: 3.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 24,18 M24,0 0,18",
    stroke: "#C8102E",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0 V18 M0,9 H24",
    stroke: "#fff",
    strokeWidth: 6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0 V18 M0,9 H24",
    stroke: "#C8102E",
    strokeWidth: 3.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.664fa56ad49138388da75670c5dafccc.svg";
export { ForwardRef as ReactComponent };